import { computed, toRef } from "vue";

import { useAccount } from "@/store/stores/account";
import { useStore as useUIStatesStore } from "@/store/stores/ui-states";

export const useSortableNewsletters = () => {
  const uiStates = useUIStatesStore();
  const sortedIds = toRef(uiStates, "newsletterOrder");

  const account = useAccount();

  const sortable = computed({
    get() {
      const newsletters = account.value.permissions.map((p) => p.newsletter);

      const map = new Map(sortedIds.value.map((id, index) => [id, index]));
      const boundary = map.size;

      newsletters.sort((a, b) => {
        const aDormant = a.status === "dormant";
        const bDormant = b.status === "dormant";

        // Move dormant newsletters to the bottom
        if (aDormant !== bDormant) {
          return aDormant ? 1 : -1;
        }

        return (map.get(a.id) ?? boundary) - (map.get(b.id) ?? boundary);
      });

      return newsletters;
    },
    set(newsletters) {
      sortedIds.value = newsletters.map((n) => n.id);
    },
  });

  return sortable;
};
